export default {
  loading: state => state.loading,
  isEditing: state => state.isEditing,
  getIsEditingOfflineSale: state => state.isEditingOfflineSale,
  getIsEditing: state => state.isEditing,
  getIsTransformingOfflineSale: state => state.isTransformingOfflineSale,
  getSaleToTransformId: state => state.saleToTransformId,
  getSaleToEditId: state => state.saleToEditId,
  getSummaryNote: state => state.summaryNote,
  getAlreadySaved: state => state.alreadySaved,
  getAlreadySynced: state => state.alreadySynced,
  getSaleToEditId: state => state.saleToEditId,
  getOfflineSales: state => state.offlineSales,
  getIsSyncingOfflineSales: state => state.isSyncingOfflineSales,
  getSaleCode: state => state.saleCode,
  getShowRGfield: state => state.showRGfield,
}
